import React from "react";
import { CheckIcon, ShieldCheckIcon } from "lucide-react";
import { CTAButton } from "../CTAButton";
import { guaranteeItems } from "../../data/content";
export function GuaranteeSection() {
  return <section className="w-full bg-white px-5 py-16 sm:py-24" data-id="element-150" data-mp="1kb2gy3fa9p8g">
      <div className="mx-auto max-w-3xl rounded-3xl bg-sand p-6 text-center sm:p-12" data-id="element-151" data-mp="1k9j4knwqzyby">
        <div className="mx-auto flex h-24 w-24 flex-col items-center justify-center rounded-full border-4 border-gold-500 bg-navy-900" data-id="element-152" data-mp="1faok7hj4u1pq">
          <ShieldCheckIcon className="h-7 w-7 text-gold-400" aria-hidden="true" data-id="element-153" data-mp="15e3dmrrgsijs" />
          <span className="mt-0.5 text-[11px] font-extrabold uppercase tracking-wider text-white" data-id="element-154" data-mp="11d01ogcjf6nu">7 days</span>
        </div>
        <h2 className="mt-5 font-serif text-[30px] font-bold leading-tight text-ink sm:text-4xl" data-id="element-155" data-mp="weoqo2aiaq41">My 7-day guarantee</h2>
        <p className="mx-auto mt-4 max-w-xl text-lg leading-relaxed text-ink/85" data-id="element-156" data-mp="2vppv6wyzudup">
          I want you to explore the Clinical Pathway™ before deciding whether it belongs in your professional learning workflow. For 7 days, you can:
        </p>
        <ul className="mx-auto mt-6 grid max-w-xl grid-cols-1 gap-2.5 text-left sm:grid-cols-2" data-id="element-157" data-mp="1g76evpzjtx8f">
          {guaranteeItems.map(g => <li key={g} className="flex items-center gap-2.5 rounded-xl bg-white px-4 py-3 text-[15px] font-semibold text-ink" data-id="element-158" data-mp="174x552c3u7w3">
              <CheckIcon className="h-4 w-4 shrink-0 text-success" aria-hidden="true" data-id="element-159" data-mp="1c3ry2x3sdctx" />
              {g}
            </li>)}
        </ul>
        <p className="mx-auto mt-6 max-w-xl text-base leading-relaxed text-muted" data-id="element-160" data-mp="23u682i8oi50b">
          If you decide the system isn’t useful for your professional learning, you can request a refund according to the purchase terms. No complicated process.
        </p>
        <div className="mx-auto mt-8 max-w-xl" data-id="element-161" data-mp="1v09q7fmjreqp">
          <CTAButton label="Try it risk-free for 7 days" data-id="element-162" data-mp="2ir5dq0jyzns5" />
        </div>
      </div>
    </section>;
}